module.exports = __webpack_public_path__ + "static/media/Template_19.b1222a1d.png";